/** Failed module imports remain rejected in the browser cache until a document reload. */
export function isModuleLoadError(error: unknown) {
  const message = error instanceof Error ? error.message : typeof error === 'string' ? error : ''
  return /failed to fetch dynamically imported module|importing a module script failed|error loading dynamically imported module|loading chunk .+ failed|failed to load module script/i.test(
    message,
  )
}
